import FactoryEventsPage from './FactoryEventsPage';

/** What the machines did: tasks started, tokens and tasks finished. */
const ReportsPage = () => (
  <FactoryEventsPage
    kind="report"
    title="Reports"
    subtitle="What the machines produced — every task started and every drum finished."
  />
);

export default ReportsPage;
